/**
 * Convert a string to an ArrayBuffer.
 *
 * @param str - The string to convert.
 * @returns The ArrayBuffer.
 */
export function convertStringToArrayBuffer(str: string) {
  const textEncoder = new TextEncoder();
  return textEncoder.encode(str).buffer;
}

/**
 * Convert a File to an ArrayBuffer.
 *
 * @param file - The File to convert.
 * @returns The ArrayBuffer.
 */
export function convertFileToArrayBuffer(file: File): Promise<ArrayBuffer | null> {
  return new Promise((resolve, reject) => {
    if (!file || !file.name) {
      reject(new Error());
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      const arrayBuffer: ArrayBuffer | null | string = reader.result;

      if (arrayBuffer === null) {
        resolve(null);
        return;
      }
      if (typeof arrayBuffer === 'string') {
        resolve(convertStringToArrayBuffer(arrayBuffer) as ArrayBuffer);
        return;
      }
      if (!arrayBuffer) {
        reject(new Error());
        return;
      }

      resolve(arrayBuffer);
    };
    reader.onerror = () => reject(new Error());
    reader.readAsArrayBuffer(file);
  });
}
